import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { AuthGuard } from '../auth/AuthGuard';
import { TenantAuthGuard } from '../auth/TenantAuthGuard';
import Main from '../layouts/Main';
import AuthCallback from '../pages/AuthCallback';
import AuthError from '../pages/AuthError';
import Login from '../pages/Login/Login';
import NotFound from '../pages/NotFound';
import Policy from '../pages/Policy/Policy';
import PolicySearch from '../pages/PolicySearch/PolicySearch';
import Questionnaire from '../pages/Questionnaire/Questionnaire';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* Public routes - no auth required */}
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth/error" element={<AuthError />} />

        {/* Tenant-aware routes: auth requirement is determined per tenant via SettingsAPI */}
        <Route path="/:orgId" element={<TenantAuthGuard />}>
          <Route path="search" element={<Main />}>
            <Route index element={<PolicySearch />} />
          </Route>
        </Route>

        <Route path="/policy/:orgId" element={<TenantAuthGuard />}>
          <Route path=":id" element={<Main />}>
            <Route path=":vid" element={<Policy />} />
            <Route index element={<Policy />} />
          </Route>
        </Route>

        {/* Protected routes - always require auth */}
        <Route element={<AuthGuard />}>
          <Route
            path="/questionnaire"
            element={<Main isQuestionnaire={true} />}
          >
            <Route index element={<Questionnaire />} />
          </Route>

          {/* Global NotFound inside Main layout */}
          <Route path="*" element={<Main />}>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
